import { applyTradeToBar } from "./tickAggregator.js";

export function makeTvDatafeed({baseUrl}) {

    const subscriptions = new Map();
    const lastBarCache = new Map();

    return {
        onReady: (cb) => {
            const url = new URL(`${baseUrl}/config`);

            fetch(url.toString(), {cache: "no-store"}).then((response) => {
                response.json().then((data) => {
                    cb(data);
                })
            })
        },

        resolveSymbol: (symbolName, onResolve) => {
            const url = new URL(`${baseUrl}/symbols`);
            url.searchParams.set("symbol", symbolName);

            fetch(url.toString(), {cache: "no-store"}).then((response) => {
                response.json().then((data) => {
                    onResolve(data);
                })
            });
        },

        getBars: async (symbolInfo, resolution, periodParams, onHistory, onError) => {
            try {
                const {from, to, countBack} = periodParams;

                const url = new URL(`${baseUrl}/history`);
                url.searchParams.set("symbol", symbolInfo.ticker);
                url.searchParams.set("resolution", resolution);
                url.searchParams.set("from", String(from));
                url.searchParams.set("to", String(to));

                if (countBack) {
                    url.searchParams.set("countback", String(countBack));
                }

                const res = await fetch(url.toString(), {cache: "no-store"});
                const json = await res.json();

                if (json.s !== "ok") return onHistory([], {noData: true});

                const bars = json.t.map((t, i) => ({
                    time: t * 1000, // UDF seconds -> ms
                    open: Number(json.o[i]),
                    high: Number(json.h[i]),
                    low: Number(json.l[i]),
                    close: Number(json.c[i]),
                    volume: json.v?.[i] == null ? 0 : Number(json.v?.[i]),
                }));

                onHistory(bars, {noData: bars.length === 0});
            } catch (e) {
                onError(e);
            }
        },

        subscribeBars: async (symbolInfo, resolution, onRealtimeCallback, subscriberUID, onResetCacheNeededCallback) => {
            const symbol = symbolInfo.ticker;
            const key = `${symbol}|${resolution}`;

            let curTime = Math.floor(Date.now() / 1000)
            try {
                const url = new URL(`${baseUrl}/time`)
                const timeResp = await fetch(url.toString(), {cache: "no-store"});
                if (timeResp.ok) {
                    const time = await timeResp.text();
                    if (!isNaN(time)) {
                        curTime = Number(time);
                    }
                }
            } catch {
                // uses browser time
            }

            try {
                const url = new URL(`${baseUrl}/history`);
                url.searchParams.set("symbol", symbol);
                url.searchParams.set("resolution", resolution);
                url.searchParams.set("from", String(curTime - 2 * 86400));
                url.searchParams.set("to", String(curTime));
                url.searchParams.set("countback", "2");

                const res = await fetch(url.toString(), {cache: "no-store"});
                const json = await res.json();

                if (json.s === "ok" && json.t?.length) {
                    const i = json.t.length - 1;
                    lastBarCache.set(key, {
                        time: json.t[i] * 1000,
                        open: Number(json.o[i]),
                        high: Number(json.h[i]),
                        low: Number(json.l[i]),
                        close: Number(json.c[i]),
                        volume: Number(json.v?.[i] ?? 0),
                    });
                }
            } catch {
                // if seeding fails, start from trades
            }

            const channelName = `exchange.public.${pageData.market.id}`;
            const eventName = ".public_trade.created";

            Echo.channel(channelName)
                .listen(eventName, ({trade}) => {
                    if (pageData.market.title !== symbol.replace('/', '_')) {
                        return;
                    }

                    const amount = Number(trade.amount);
                    const price = Number(trade.price);

                    const normalizedTick = {
                        ts: Date.parse(trade.date),
                        price: price,
                        volume: price * amount,
                    };

                    const prevBar = lastBarCache.get(key);
                    const nextBar = applyTradeToBar(prevBar, normalizedTick, resolution);
                    if (!prevBar || nextBar.time !== prevBar.time || nextBar.close !== prevBar.close || nextBar.volume !== prevBar.volume) {
                        lastBarCache.set(key, nextBar);
                        onRealtimeCallback(nextBar);
                    }
                });

            subscriptions.set(subscriberUID, () => {
                Echo.leave(channelName);
            });
        },

        unsubscribeBars: (subscriberUID) => {
            const cleanup = subscriptions.get(subscriberUID);
            if (cleanup) {
                cleanup();
            }
            subscriptions.delete(subscriberUID);
        },
    };
}
